export const REFERRAL_PROVIDER_NAME_MIN_LENGTH = 8;
export const REFERRAL_CITY_MIN_LENGTH = 2;
export const TREATMENT_PLAN_V3_REFERRAL_ROW_DATE_FORMAT = 'M/D/YY';

export const TREATMENT_PLAN_V3_DIAGNOSIS_TOOL_OPTIONS = [
  {
    value: 'ADOS-2 (Autism Diagnostic Observation Schedule)',
    label: 'ADOS-2 (Autism Diagnostic Observation Schedule)',
  },
  {
    value: 'Autism Spectrum Rating Scales™ (ASRS®)',
    label: 'Autism Spectrum Rating Scales™ (ASRS®)',
  },
  { value: 'AQ (Autism Spectrum Quotient)', label: 'AQ (Autism Spectrum Quotient)' },
  {
    value: 'CARS-2 (Childhood Autism Rating Scale)',
    label: 'CARS-2 (Childhood Autism Rating Scale)',
  },
  { value: 'GARS-2 (Gilliam Autism Rating Scale)', label: 'GARS-2 (Gilliam Autism Rating Scale)' },
  {
    value: 'M-CHAT-R/F (Modified Checklist for Autism in Toddlers)',
    label: 'M-CHAT-R/F (Modified Checklist for Autism in Toddlers)',
  },
  {
    value: 'Parents’ Evaluation of Developmental Status (PEDS)',
    label: 'Parents’ Evaluation of Developmental Status (PEDS)',
  },
  { value: 'SRS-2 (Social Responsiveness Scale)', label: 'SRS-2 (Social Responsiveness Scale)' },
  {
    value: 'STAT (Screening Tool for Autism in Toddlers)',
    label: 'STAT (Screening Tool for Autism in Toddlers)',
  },
  { value: 'Tele-ASD-Peds', label: 'Tele-ASD-Peds' },
  { value: 'Other', label: 'Other' },
] as const;
